import {
	Directive,
	ElementRef,
	HostListener,
	inject,
	Input,
	NgModule,
	Output,
} from '@angular/core';
import { fromEvent, merge, timer } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';

import { MediaQueryService } from '~app-client/core/services';

@Directive({
	standalone: false,
	selector: '[longPress]',
	host: {
		'[class.disable-text-selection]': 'isTouchDevice',
	},
})
export class LongPressDirective<T extends HTMLElement> {
	private readonly mediaQueryService = inject(MediaQueryService);

	public isTouchDevice = 'ontouchstart' in window;

	readonly desktopLongPress$ = fromEvent(this.nativeElement, 'contextmenu');
	private readonly touchLongPress$ = fromEvent(this.nativeElement, 'touchstart').pipe(
		switchMap((event) => {
			return timer(this.longPressTimer).pipe(
				map(() => {
					return event;
				}),
				takeUntil(
					merge(
						fromEvent(window, 'touchend'),
						fromEvent(window, 'touchmove'),
						fromEvent(window, 'scroll', {
							capture: true,
						})
					)
				)
			);
		})
	);

	@Input()
	public longPressTimer = 500;

	@Output('longPress')
	public readonly longPress$ = this.mediaQueryService.getQuery$(MediaQueryService.canHover).pipe(
		switchMap((canHover) => {
			return canHover ? this.desktopLongPress$ : this.touchLongPress$;
		})
	);

	public get nativeElement(): T {
		return this.elementRef.nativeElement;
	}

	constructor(private readonly elementRef: ElementRef<T>) {}

	@HostListener('contextmenu', ['$event'])
	public onContextMenu(event: MouseEvent): void {
		event.preventDefault();
	}
}

@NgModule({
	declarations: [LongPressDirective],
	exports: [LongPressDirective],
})
export class LongPressModule {}
